import { AnalysisStatus } from '@/enums';
import { AnalysisEntity, AnalysisParams, MetaTag } from '@/interfaces';
import { newQueryKeys } from '@/queries/queryKeys';
import { AnalysisService } from '@/services';
import { CustomError, errorNotification } from '@/utils';
import { useQueryClient as useNewQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import _get from 'lodash/get';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useAnalysisMutation = (props: {
  handleNavigate: (
    props: AnalysisParams,
    remove?: (keyof AnalysisParams)[],
  ) => void;
}) => {
  const { handleNavigate } = props;
  const queryClient = useQueryClient();
  const newQueryClient = useNewQueryClient();
  const { t } = useTranslation();
  const [rerun, setRerun] = useState<AnalysisEntity>({} as AnalysisEntity);
  const [mlError, setMlError] = useState<Record<string, MetaTag[]>>({});

  const restoreAnalysisMutation = useMutation({
    mutationFn: AnalysisService.restoreAnalysis,
    onSuccess: () => {
      notification.success({
        message: t('analysis.restoreDeletedBatchSuccess'),
      });
      newQueryClient.invalidateQueries({
        queryKey: newQueryKeys.analysis.invalidateListsKey(),
      });
    },
    onError: error =>
      errorNotification({ error: error as unknown as CustomError }),
  });

  const mutationRerun = useMutation({
    mutationFn: AnalysisService.rerunAnalysis,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [rerun.displayId] });
      newQueryClient.invalidateQueries({
        queryKey: newQueryKeys.analysis.invalidateListsKey(),
      });
      notification.success({ message: t('common.success') });
      setRerun({} as AnalysisEntity);
      handleNavigate({ status: AnalysisStatus.ANALYSING });
    },
    onError: error => {
      errorNotification({ error: error as unknown as CustomError });
    },
  });

  const removeAnalysis = useMutation({
    mutationFn: AnalysisService.removeAnalysisBatch,
    onSuccess: () => {
      notification.success({ message: t('common.deleteSuccess') });
      newQueryClient.invalidateQueries({
        queryKey: newQueryKeys.analysis.invalidateListsKey(),
      });
    },
    onError: error =>
      errorNotification({ error: error as unknown as CustomError }),
  });

  const getMLErrorMetadataMutation = useMutation({
    mutationFn: AnalysisService.getMlErrorMetaData,
    onSuccess: res => {
      setMlError(_get(res, 'data', {}));
    },
    onError: error => {
      console.error(error);
    },
  });

  //   (body: { id: string; displayId: string }) =>
  //     AnalysisService.downloadAnalysisBatchReport(body.id),
  //   {
  //     onSuccess: async (res: any, input) => {
  //       const data = res?.data || {
  //         success: [],
  //         failed: [],
  //       };

  //       if (Array.isArray(data.failed) && data.failed?.length > 0) {
  //         const grouped: Record<
  //           string,
  //           { errorCode: string; externalId: string }[]
  //         > = _groupBy(data.failed, 'errorCode');

  //         Object.keys(grouped).forEach(key => {
  //           const values = grouped[key]
  //             .map(g => g.externalId.toUpperCase())
  //             .join(', ');
  //           notification.error({
  //             message: t(`error.${key}`, {
  //               VALUES: values,
  //             }),
  //           });
  //         });
  //       }

  //       if (Array.isArray(data.success) && data.success?.length > 0) {
  //         const files = data.success;
  //         if (files.length === 1) {
  //           const item = files[0];
  //           await downloadFile(item.url, item.fileName);
  //         } else {
  //           setLoadingZip(true);
  //           await downloadFileZip(
  //             `${input?.displayId?.toUpperCase()}_Report`,
  //             files,
  //           );
  //           setLoadingZip(false);
  //         }
  //       }
  //     },
  //     onError: (error: any, input) => {
  //       setLoadingZip(false);
  //       // errorNotification({ error: error as unknown as CustomError });

  //       errorNotification({
  //         error,
  //         contentObj: {
  //           VALUES: input?.displayId?.toUpperCase(),
  //         },
  //       });
  //     },
  //   },
  // );

  return {
    restoreAnalysisMutation,
    mutationRerun,
    removeAnalysis,
    getMLErrorMetadataMutation,
    mlError,
    rerun,
    setRerun,
    setMlError,
  };
};
